import { createPortal } from 'react-dom';

const Portal = (props: { children: any }) => {
  return createPortal(props.children, document.body);
};

export default Portal;
